// Public configuration only: the website's own backend (fully independent of
// any external portal). Never place a service-role key here.
export const FC_DATA_ORIGIN = "https://gjmrdvoyuiqfmxonaxac.supabase.co";
export const FC_PUBLIC_KEY = "sb_publishable_TaC7AbkJWxcQaXXVcYCcmA_rsKUa1b4";
/** Private bucket for covers of published public events; served via short-lived signed URLs. */
export const COVER_BUCKET = "meeting-covers";
/** Public preview copies of covers for published, non-members-only events only. */
export const PUBLIC_COVER_BUCKET = "public-meeting-covers";
